import { render, staticRenderFns } from "./ElErrorLandingPage.vue?vue&type=template&id=49e9c1d6&"
import script from "./ElErrorLandingPage.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ElErrorLandingPage.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports